module.exports = __webpack_public_path__ + "static/step-3@2x-1509c73919975753acd6b21043061bd1.webp";